import * as React from 'react';
import { Chip } from '..';
var sizes = {
    thin: '20px',
    default: '24px',
    thick: '32px'
};
var priorityMap = {
    none: 'neutral6',
    lowest: 'cyan8',
    low: 'green7',
    medium: 'orange7',
    high: 'yellow8',
    highest: 'red8'
};
function mapPriority(priority, appearance) {
    /**
     * Omit the 'accent' dot if priority is 'none'
     * Otherwise use regular 'fill'
     */
    if (priority === 'none' && appearance === 'accent')
        return undefined;
    return priorityMap[priority];
}
export var Priority = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'default' : _b, _c = _a.priority, priority = _c === void 0 ? 'medium' : _c, _d = _a.appearance, appearance = _d === void 0 ? 'solid' : _d, children = _a.children, onClick = _a.onClick;
    var fill = mapPriority(priority, appearance);
    return (React.createElement(Chip, { type: onClick !== undefined ? 'selectable' : 'basic', size: size, appearance: appearance, fill: fill, color: appearance === 'solid' ? 'pureWhite' : 'pureBlack', onClick: onClick }, children));
};
//# sourceMappingURL=index.js.map